import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { responsive } from "../../utils/style";

import ThaiHealth from "../../assets/images/Thaihealth.svg";

import YT from "../../assets/icons/youtube.svg";
import FB from "../../assets/icons/facebookFooter.svg";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <UpperContainer>
        <img src={ThaiHealth} />
        <Pdpa onClick={() => navigate("/privacyNotice")}>
          นโยบายข้อมูลส่วนบุคคล
        </Pdpa>
        <div>
          <ChannelLabel>ช่องทางติดตาม</ChannelLabel>

          <IconContainer>
            <a href="https://www.youtube.com/channel/UCH5GwcRi1VMeBTg5yQ00vUg">
              <img src={YT} />
            </a>
            <a href="https://www.facebook.com/sonkthaiglairok">
              <img src={FB} />
            </a>
          </IconContainer>
        </div>
      </UpperContainer>
      <CopyRightContainer>© 2022 สงวนลิขสิทธิ์</CopyRightContainer>
    </Container>
  );
};

const Pdpa = styled.div`
  color: #ffffff;
  font-style: bold;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: right;
  gap: 18px;

  ${responsive.mobile(css`
    justify-content: center;
    margin-bottom: 32px;
  `)}
`;

const Container = styled.footer`
  font-family: Noto Sans Thai, Noto Sans;
  height: 154px;
  // position: fixed;
  // left: 0;
  // bottom: 0;
  // width: 100%;
`;

const UpperContainer = styled.div`
  display: flex;
  width: 100%;
  height: 104px;
  align-items: center;
  background: #035d40;
  padding-left: 32px;
  justify-content: space-between;
  padding-right: 32px;

  > img {
    width: 65px;
    margin-top: 8px;
  }

  ${responsive.mobile(css`
    flex-direction: column;
    align-items: center;
    height: 180px;
    justify-content: center;
    gap: 16px;

    > img {
      height: auto;
      margin-top: 15px;
    }
  `)}
`;

const CopyRightContainer = styled.div`
  display: flex;
  height: 50px;
  width: 100%;

  /* Primary/Green 800 */
  background: #01452f;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height, or 121% */
  align-items: center;
  color: #ffffff;
  padding-left: 32px;
`;

const ChannelLabel = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  /* identical to box height, or 154% */

  text-align: right;

  color: #ffffff;
`;

export default Footer;
